import React, {Component} from 'react';
import PropTypes from 'prop-types';

class EditFishForm extends Component {
  static propTypes = {
    fish: PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string,
      desc: PropTypes.string,
      status: PropTypes.string,
      price: PropTypes.number,
      quantity: PropTypes.number
    }),
    index: PropTypes.string,
    updateFish: PropTypes.func,
    deleteFish: PropTypes.func
  }

  handleChange = event => {
    const updatedFish = {
      ...this.props.fish,
      [event.currentTarget.name]: event.currentTarget.value
    };
    this.props.updateFish(this.props.index, updatedFish);
  };

  render() {
    return (
      <div className="fish-edit">
        <input
          type="text"
          name="name" onChange={this.handleChange} value={this.props.fish.name}
        />
        <input
          type="text"
          name="price" onChange={this.handleChange} value={this.props.fish.price}
        />
        <input
          type="text"
          name="quantity" onChange={this.handleChange} value={this.props.fish.quantity}
        />
        <select
          type="text"
          name="status" onChange={this.handleChange} value={this.props.fish.status}
        >
          <option value="available">
            Fresh!
          </option>
          <option value="unvailable">
            Sold Out!
          </option>
        </select>
        <textarea
          type="text"
          name="desc" onChange={this.handleChange} value={this.props.fish.desc}
        >
        </textarea>
        <input
          type="text"
          name="image" onChange={this.handleChange} value={this.props.fish.image}
        />
      <button onClick={() => this.props.deleteFish(this.props.index)}>Remove Fish</button>
      </div>
    );
  }
}


export default EditFishForm;



// WEBPACK FOOTER //
// ./src/components/EditFishForm.js